export default __webpack_public_path__ + "static/media/news48.e5071c19.jpg";